import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { IButtons } from "apiConsumers/newsApiConsumer/models/INewsArticle";
import NewTabLinkButton from "components/buttons/NewTabLinkButton";

const useStyles = makeStyles((theme: Theme) => {
    const buttonSpacing = theme.spacing(1);

    return createStyles({
        button: { marginBottom: buttonSpacing, marginRight: buttonSpacing },
    });
});

interface IProps {
    buttons?: IButtons;
}

export default function ButtonsWidget(props: IProps) {
    const { buttons } = props;
    const classes = useStyles();

    if (typeof buttons === "undefined") return null;

    const { direction = "row", size = "medium", buttonWidgets } = buttons;

    if (typeof buttonWidgets === "undefined") return null;

    return (
        <div
            style={{
                display: "flex",
                flexDirection: direction,
                flexWrap: "wrap",
                justifyContent: "center",
            }}
        >
            {buttonWidgets.map((button, i) => {
                const { text, href } = button;

                if (typeof text === "undefined" || typeof href === "undefined") return null;

                return (
                    <div key={`articleButton_${i}`} className={classes.button}>
                        <NewTabLinkButton href={href} variant="secondary" size={size}>
                            {text}
                        </NewTabLinkButton>
                    </div>
                );
            })}
        </div>
    );
}
